import { Component, Inject, Output, EventEmitter, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer } from '@angular/platform-browser';

declare var i18nVS: any;
declare var GetLinesFromCity: any; // URL dinamica para que Funcione tanto en Liferay como en VSC
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var nombreLineaClicada: any;
declare var colorLineaClicada: any;
declare var IDLineaClicada: any;
declare var portletNameServiceInformationLiferay: any; // Nombre del portlet en Liferay

@Component({
    selector: 'app-service-information-lineas',
    templateUrl: './lineas.component.html',
    styleUrls: ['../service-information.component.css']
})

export class LineasComponent implements OnInit {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = i18nVS;

    // Esta variable nos indica si estamos tirando de los servicios alsa o los de transit
    servicesAlsa = false;
    loadingLinesClass = '';

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    jsonData;
    lineas = []; filtroLineas = ''; // Necesario para recoger el onChange event

    portletName = ''; // Nombre del portlet

    @Output () onLineSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output () onLinesLoad: EventEmitter<any> = new EventEmitter<any>();
    @Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    getBackground (color) {
        return this._sanitizer.bypassSecurityTrustStyle('#' + color.replace("#",""));
    }

    leerDatos (): Observable<Response> {
        const body = this.portletName + 'cityId=' + idCiudadLiferay;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this.http.post(GetLinesFromCity, body, httpOptions);
    }

    public concatenarOrigenDestino (origen, destino) {
        if ((origen !== '' && origen !== null && typeof origen !== 'undefined') &&
            (destino !== '' && destino !== null && typeof destino !== 'undefined')) {
                return origen + ' - ' + destino;
        } else {
            if (origen !== '' && origen !== null && typeof origen !== 'undefined') {
                return origen;
            } else {
                if (destino !== '' && destino !== null && typeof destino !== 'undefined') {
                    return destino;
                }
            }
        }
    }

    public setIdLinea (id) {
        var LineaClicada = this.lineas.filter(item => item.id === id[0]);
        colorLineaClicada = '#' + LineaClicada[0].color.replace("#",""); // El color que se va a usar en muchos componentes
        nombreLineaClicada = LineaClicada[0].name; // Como el ID es unico siempre nos llegara una unica linea
        IDLineaClicada = LineaClicada[0].id; // El nombre que sale dentro del circulo en la parte de arriba
        this.filtrarLineas();

        this.onLineSelected.emit( LineaClicada[0] );
    }

    public RecogerLineas () { // Recoge las lineas de un JSON
        this.leerDatos().subscribe( res => this.comprobandoJson(res), (err) => this.errorEnElJson(err), () => this.filtrarLineas());
    }

    public comprobandoJson (res) {
        try {
            this.jsonData = res;

            // Si las lineas tienen apellido sabremos que los servicios son de alsa y no de transit
            if (typeof this.jsonData.lines[0].surname != 'undefined') {
                this.servicesAlsa = true;
            }
        } catch (error) {
            this.errorEnElJson(error);
        }
    }

    public errorEnElJson(error) {
        console.log('Error WS ' + error);
        this.onWebServiceError.emit(true);
    }

    public filtrarLineas() {
        try {
            console.log('Filtrando lineas');
            this.lineas = this.jsonData.lines;
            this.ordenarLineas();

            this.onLinesLoad.emit( this.lineas );
            this.loadingLinesClass = 'invisible';

            // Filtro de lineas
            this.lineas = this.lineas.filter(item =>
            (item.name + ' ' + (item.surname || '').toUpperCase() + ' ' + (item.outgoing.lineHeader || '') + ' ' + (item.outgoing.lineEnd || '').toUpperCase())
            .search(this.filtroLineas.toUpperCase()) !== -1);
        } catch (error) {
            this.errorEnElJson(error);
        }
    }

    public ordenarLineas () {
        this.lineas.sort( function (a, b) { return a.number - b.number; } );
    }

    public mostrarNombre(linea) {
        if (this.servicesAlsa) {
            return linea.surname;
        } else {
            return this.concatenarOrigenDestino(linea.outgoing.lineHeader, linea.outgoing.lineEnd);
        }
    }

    public lineLastName(array) {
        if (array.length > 0) {
            return array[array.length - 1].name;
        } else {
            return '';
        }
    }

    public lineFirstName(array) {
        if (array.length > 0) {
            return array[0].name;
        } else {
            return '';
        }
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameServiceInformationLiferay;
        this.RecogerLineas();
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(@Inject(HttpClient) private http, private _sanitizer: DomSanitizer) { }
}



// WEBPACK FOOTER //
// ./src/app/lineas/lineas.component.ts